import { render, staticRenderFns } from "./HotelPriceRuleComponent.vue?vue&type=template&id=1070c410&scoped=true"
import script from "./HotelPriceRuleComponent.vue?vue&type=script&lang=js"
export * from "./HotelPriceRuleComponent.vue?vue&type=script&lang=js"
import style0 from "./HotelPriceRuleComponent.vue?vue&type=style&index=0&id=1070c410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1070c410",
  null
  
)

export default component.exports